import { useState, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { SnackbarProvider } from "./features/snackbar/context/SnackbarContext";
import { ProtectedRoute } from "./routes/ProtectedRoute";
import { LoginPage } from "./pages/LoginPage";
import { HomePage } from "./pages/HomePage";
import { FaqPage } from "./pages/FaqPage";
import { SSOCallbackPage } from "./pages/SSOCallbackPage";
import axiosInstance from "./config/axiosConfig";
import { REACT_BASE_URL } from "./config/apiConfig";
import {
  AUTH_PROVIDER,
    clearAuthSession,
    getAuthProvider,
    getStoredRefreshToken,
    hasValidStoredSession,
    storeLogoutNotification,
  } from "./features/auth/session";
import "./App.css";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

  const navigate = useNavigate();
  // Verifica se l'utente è già loggato al mount
  useEffect(() => {
    if (hasValidStoredSession()) {
      setIsLoggedIn(true);
    }
  }, []);

  const getApplicationLoginUrl = () => {
    const normalizedReactBaseUrl = REACT_BASE_URL.replace(/\/$/, "");

    return `${normalizedReactBaseUrl}/login`;
  };

  const handleLogout = async () => {
    const refreshToken = getStoredRefreshToken();
    const authProvider = getAuthProvider();

    try {
      if (authProvider === AUTH_PROVIDER.MICROSOFT_ENTRA_ID) {
        const response = await axiosInstance.post("/oauth/sso/logout", {
          refresh_token: refreshToken,
          post_logout_redirect_uri: getApplicationLoginUrl(),
        });

        storeLogoutNotification(
          "Logout effettuato correttamente. Effettua un nuovo accesso per continuare."
        );

        clearAuthSession();
        setIsLoggedIn(false);

        if (response.data.logout_url) {
          window.location.href = response.data.logout_url;
          return;
        }
      } else {
        await axiosInstance.post("/oauth/logout", {
          refresh_token: refreshToken,
        });

        storeLogoutNotification(
          "Logout effettuato correttamente. Effettua un nuovo accesso per continuare."
        );
      }
    } catch (error) {
      console.error("Errore durante il logout:", error);

      storeLogoutNotification(
        "Sessione locale chiusa. Effettua un nuovo accesso per continuare."
      );
    }

    clearAuthSession();
    setIsLoggedIn(false);
    navigate("/login", { replace: true });
  };

  return (
    <SnackbarProvider>
      <Routes>
        <Route
          path="/login"
          element={
            isLoggedIn ? (
              <Navigate to="/" replace />
            ) : (
              <LoginPage setIsLoggedIn={setIsLoggedIn} />
            )
          }
        />

        {/* NUOVO: Route per callback SSO */}
        <Route
          path="/auth/sso/callback"
          element={<SSOCallbackPage setIsLoggedIn={setIsLoggedIn} />}
        />

        <Route
          path="/"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <HomePage
                isChatOpen={isChatOpen}
                setIsChatOpen={setIsChatOpen}
                isUploadModalOpen={isUploadModalOpen}
                setIsUploadModalOpen={setIsUploadModalOpen}
                onLogout={handleLogout}
              />
            </ProtectedRoute>
          }
        />

        <Route path="/faq" element={<FaqPage />} />

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </SnackbarProvider>
  );
};

export default App;
